var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTabCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#343A40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.454 21.783c.917 0 1.615-.238 2.095-.714.48-.476.72-1.173.72-2.09l-.001-10.437c.422-.034.757-.186 1.005-.455.283-.308.424-.716.424-1.225V5.305c0-.509-.141-.917-.424-1.225-.283-.308-.679-.462-1.187-.462H3.5c-.494 0-.886.154-1.176.462-.29.308-.436.716-.436 1.225v1.557c0 .509.142.917.425 1.225.247.27.581.42 1.001.455h.003v10.437c0 .924.238 1.623.715 2.095.476.473 1.176.71 2.1.71h11.322zm2.438-14.212H3.693c-.265 0-.462-.071-.59-.215-.13-.143-.194-.343-.194-.601V5.412c0-.265.064-.467.193-.607.13-.14.326-.21.591-.21h16.2c.257 0 .452.07.585.21.132.14.199.342.199.607v1.343c0 .258-.067.458-.2.601-.132.144-.327.215-.585.215zm-2.449 13.235H6.132c-.58 0-1.024-.154-1.332-.462-.308-.308-.462-.752-.462-1.332L4.337 8.549h14.91v10.463c0 .58-.157 1.024-.472 1.332-.315.308-.759.462-1.332.462zm-2.191-8.25c.179 0 .322-.058.43-.172.107-.115.16-.265.16-.451v-.29c0-.187-.053-.335-.16-.446-.108-.111-.251-.167-.43-.167H8.334c-.18 0-.322.056-.43.167-.107.11-.161.26-.161.446v.29c0 .186.054.336.161.45.108.115.25.173.43.173h6.918z",
    transform: "translate(-121 -1548) translate(0 1542) translate(95) translate(22 6) translate(4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTabCategory);
export default __webpack_public_path__ + "static/media/ic_tab_category.55989b84582706cfcd846d31852c8c02.svg";
export { ForwardRef as ReactComponent };